import { Map as ImmutableMap } from 'immutable';
import { BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB } from 'crm-events-components/internal/BET/timeline/constants/BETTimelineConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ENGAGEMENT_TYPE_TO_I18N_KEY, ENGAGEMENTS_NOTES, ENGAGEMENTS_EMAIL, ENGAGEMENTS_CALLS, ENGAGEMENTS_MEETINGS } from 'crm-events-data';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const BET_TABS = [BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB];
const ENGAGEMENT_TYPE_TO_KNOWLEDGE_URL = ImmutableMap({
  [ENGAGEMENTS_NOTES]: 'https://knowledge.hubspot.com/articles/kcs_article/contacts/how-do-i-mention-someone-in-the-crm',
  [ENGAGEMENTS_EMAIL]: 'https://knowledge.hubspot.com/articles/kcs_article/email-tracking/connect-your-inbox-to-hubspot',
  [ENGAGEMENTS_CALLS]: 'https://knowledge.hubspot.com/articles/kcs_article/calling/use-the-calling-tool',
  [ENGAGEMENTS_MEETINGS]: 'https://knowledge.hubspot.com/meetings-tool/use-meetings'
});
const ZERO_STATE_ENGAGEMENT_TYPE_TRANSLATION_KEYS = {
  calls: 'timeline.zeroState.calls',
  emails: 'timeline.zeroState.emails',
  learnMore: 'timeline.zeroState.learnMore',
  meetings: 'timeline.zeroState.meetings',
  notes: 'timeline.zeroState.notes',
  tasks: 'timeline.zeroState.tasks'
};
function TimelineZeroState({
  favoriteEventOverride
}) {
  const overrideEngagementType = favoriteEventOverride && favoriteEventOverride.get('eventTypes') && favoriteEventOverride.get('eventTypes').first();
  if (!overrideEngagementType || BET_TABS.includes(overrideEngagementType)) {
    return null;
  }
  const knowledgeBaseUrl = ENGAGEMENT_TYPE_TO_KNOWLEDGE_URL.get(overrideEngagementType);
  if (!knowledgeBaseUrl) {
    return null;
  }
  const engagementTypeKey =
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  ENGAGEMENT_TYPE_TO_I18N_KEY[overrideEngagementType];
  const zorseLink = /*#__PURE__*/_jsx(KnowledgeBaseButton, {
    url: knowledgeBaseUrl,
    useZorse: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.zeroState.learnMore"
    })
  });
  const message = ZERO_STATE_ENGAGEMENT_TYPE_TRANSLATION_KEYS[engagementTypeKey];
  return /*#__PURE__*/_jsx(Text, {
    textAlign: "center",
    paddingBlockStart: "1200",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: message,
      options: {
        learnMoreLink: zorseLink
      }
    })
  });
}
export default TimelineZeroState;